import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { ViewTitle } from '../components/reusable'
import { Page } from '../ui'
import { NeedsSortingClientsView } from '../components/views/needsSortingClientsView'

function NeedsSortingClients() {
    return (
        <div className="needsSortingClients">
            <Sidebar />
            <MainView>
                <Page>
                    <ViewTitle text={'Needs Sorting'} />
                    <NeedsSortingClientsView />
                </Page>
            </MainView>
        </div>
    )
}

export default NeedsSortingClients
